import styled from "styled-components";
import { color } from "../../shared/styles";

export const Container = styled.div`
    z-index: 9999;
    position: fixed;
    right: 0px;
    top: 92px;
`;

export const StyledToast = styled.div`
    position: relative;
    margin-bottom: 5px;
    max-width: 500px;
    padding: 12px 16px;
    border-radius: 1.2rem;
    background: #ffe6e0;
    cursor: pointer;
    transition: all 0.3s;
    transform: translateZ(0);
    display: flex;
    justify-content: space-between;

    &.jira-toast-enter,
    &.jira-toast-exit.jira-toast-exit-active {
        opacity: 0;
        right: -10px;
    }

    &.jira-toast-exit,
    &.jira-toast-enter.jira-toast-enter-active {
        opacity: 1;
        right: 0;
    }

    .title {
        font-size: 14px;
        line-height: 14px;
        font-weight: 700;
        color: rgba(224, 27, 36, 0.82);
    }

    .message {
        margin-top: 4px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(224, 27, 36, 0.6);
    }

    .close-icon-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }
`;

interface ToastProps {
    type: string;
    duration: number;
}

export const NewStyledToast = styled.div<ToastProps>`
    background: #ffe6e0;
    pointer-events: auto;
    min-width: 352px;
    height: auto;
    flex-shrink: 0;
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    background: ${(props) =>
        props.type === "success"
            ? color.status.SUCCESS_LIGHT
            : props.type === "warning"
                ? color.status.WARNING_LIGHT
                : color.status.DANGER_LIGHT};
    cursor: pointer;
    transition: all 0.3s;
    transform: translateZ(0);

    /* Progress bar (border-top simulator) */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
        width: 100%;
        background-color: ${(props) =>
            props.type === "success"
                ? color.status.SUCCESS
                : props.type === "warning"
                    ? color.status.WARNING
                    : color.status.FAIL};
        animation: shrink-bar linear forwards;
        animation-duration: ${(props) => props.duration * 1000 || 3000}ms;
    }

    &.app-toast-enter,
    &.app-toast-exit.app-toast-exit-active {
        opacity: 0;
        right: -10px;
    }

    &.app-toast-exit,
    &.app-toast-enter.app-toast-enter-active {
        opacity: 1;
        right: 0;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .message {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        white-space: pre-line; 
    }
`;